export type ServiceType = "skip" | "man-van" | "grab";

export type SkipSize = "4-yard" | "6-yard" | "8-yard" | "10-yard" | "12-yard";
export type LoadSize = "small" | "medium" | "large" | "full-van";
export type MaterialType = "soil" | "hardcore" | "mixed-inert" | "green-waste";
export type SupplementalItemId = "mattress" | "fridge-freezer" | "tyres" | "plasterboard" | "gas-bottle";
export type PaymentStatus = "idle" | "started" | "succeeded" | "failed";

export type BookingDetails = {
  date: string;
  timeSlot: string;
  fullName: string;
  email: string;
  phone: string;
  addressLine1: string;
  addressLine2: string;
  townCity: string;
  county: string;
  postcode: string;
  isCompanyBooking: boolean;
  companyName: string;
  driverNotes: string;
};

export type SupplementalQuantities = Record<SupplementalItemId, number>;

export type PricingLine = {
  label: string;
  amount: number;
};

export type PricingResult = {
  baseServicePrice: number;
  supplementalItemsTotal: number;
  discount: number;
  vat: number;
  totalPayable: number;
  lines: PricingLine[];
};

export type DiscountResult = {
  code: string;
  type: "fixed" | "percentage";
  value: number;
  amount: number;
  message: string;
};

export type BookingState = {
  currentStep: number;
  postcode: string;
  service: ServiceType | "";
  skipSize: SkipSize | "";
  loadSize: LoadSize | "";
  materialType: MaterialType | "";
  supplementalItems: SupplementalQuantities;
  bookingDetails: BookingDetails;
  discountCode: string;
  discountResult: DiscountResult | null;
  acceptedTerms: boolean;
  pricingResult: PricingResult | null;
  paymentStatus: PaymentStatus;
  paymentIntentId: string;
  bookingReference: string;
};

export const supplementalItemIds: SupplementalItemId[] = [
  "mattress",
  "fridge-freezer",
  "tyres",
  "plasterboard",
  "gas-bottle",
];

export const defaultSupplementalItems: SupplementalQuantities = {
  mattress: 0,
  "fridge-freezer": 0,
  tyres: 0,
  plasterboard: 0,
  "gas-bottle": 0,
};

export const defaultBookingDetails: BookingDetails = {
  date: "",
  timeSlot: "",
  fullName: "",
  email: "",
  phone: "",
  addressLine1: "",
  addressLine2: "",
  townCity: "",
  county: "",
  postcode: "",
  isCompanyBooking: false,
  companyName: "",
  driverNotes: "",
};

export const defaultBookingState: BookingState = {
  currentStep: 0,
  postcode: "",
  service: "",
  skipSize: "",
  loadSize: "",
  materialType: "",
  supplementalItems: defaultSupplementalItems,
  bookingDetails: defaultBookingDetails,
  discountCode: "",
  discountResult: null,
  acceptedTerms: false,
  pricingResult: null,
  paymentStatus: "idle",
  paymentIntentId: "",
  bookingReference: "",
};
